<template>
  <span class="download-target__graphs" id="las-downloadable-region">
    <div id="viewership-graph-pdf">
      <viewership-graph 
        :viewershipData="viewershipData"
        :networks="networks"
        :isGraphOnly="true"
        />
    </div>
    <div id="universe-graph-pdf">
      <universe-stability-graph :data="universeData"/>
    </div>
    <div id="age-market-breaker-graph-pdf">
      <age-market-breaker-graph
      :data="ageMarketBreakerData"
      :meanAge="meanAge"/>
    </div>
    <div id="age-graph-pdf">
      <age-graph :data="ageData" :meanAge="meanAge" />
    </div>
    <div id="income-graph-pdf">
      <income-graph :data="incomeData"/>
    </div>
  </span> 
</template>

<script>
import AgeMarketBreakerGraph from './AgeMarketBreakerGraph'
import AgeGraph from './AgeDistributionGraph'
import IncomeGraph from './IncomeGraph'
import UniverseStabilityGraph from './UniverseStabilityGraph'
import ViewershipGraph from './viewership'

export default {
  components: {
    AgeMarketBreakerGraph,
    AgeGraph,
    IncomeGraph,
    UniverseStabilityGraph,
    ViewershipGraph
  },
  props: {
    viewershipData: {
      type: Object
    },
    networks: {
      type: Array,
      required: true
    },
    universeData: {
      type: Object
    },
    ageMarketBreakerData: {
      type: Object
    },
    ageData: {
      type: Object
    },
    incomeData: {
      type: Object
    },
    meanAge: {
      type: String
    }
  },
  // computed: {
  //   networksToHighlight () {
  //     return this.$store.getters.networksToShowDayParts || []
  //   },
  //   dataForGraph () {
  //     return transformHistoricalViewershipGraphData(this.networks, this.viewershipData, [])
  //   },
  //   axises () {
  //     return historicalViewershipGraphAxises(this.viewershipData)
  //   }
  // },
  mounted () {
    console.log({
      networks: this.networks,
      viewershipData: this.viewershipData,
      universeData: this.universeData,
      ageMarketBreakerData: this.ageMarketBreakerData,
      ageData: this.ageData,
      incomeData: this.incomeData,
      meanAge: this.meanAge
    })
  }
}
</script>

<style lang="scss">
.download-target {
  &__graphs {
    display: block;
    position: fixed;
    bottom: 0;
    left:0;
    width: 1600px;
    height: 0;
    overflow: hidden;
    background: white;
  }
}
</style>



// WEBPACK FOOTER //
// LASDownloadableGraphs.vue?108389dc